import { ContainerComponent, wrap } from 'AppReact';
import { SecondaryTextXs } from 'atoms';
import internalState from './internalState';
import { MakeReadyItemCellWrapper, Td, Px2 } from 'wrappers';
import { textEllipsis } from 'utils/ellipsis';
import { Popup } from '../../atoms';
import { TooltipWrapper } from './wrappers';


export const definition = {
  name: 'TextCell',
  controller: {},
  initialProps: ({ data, displayConfetti, showCheckboxes }) => ({ displayConfetti, data, showCheckboxes }),
  props: internalState,
  elements: [
    {
      wrapper: MakeReadyItemCellWrapper,
      name: 'Selector',
      renderIf: ({ displayConfetti }) => !displayConfetti,
      displayState: ({ showCheckboxes }) => ({ background: showCheckboxes ? '#F7F7F7' : '' }),
      elements: [
        {
          wrapper: TooltipWrapper,
          name: "TooltipWrapper",
          elements: [
            {
              component: wrap(SecondaryTextXs, Px2),
              name: 'Text',
              displayValue: ({ data }) => textEllipsis(data?.data ?? '-', 30)
            },
            {
              component: Popup,
              name: 'Popup',
              displayValue: ({ data }) => data?.data,
              renderIf: ({ data }) => !!(data?.data?.length > 30),
              displayState: ({}) => ({ direction: "right", breakWord: true })
            }
          ]
        },
      ]
    },
  ]
}

export default wrap(ContainerComponent(definition), Td)